import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
import { KnowledgeSegmentApi } from '@/api/ai/knowledge/segment';
import { useMessage } from '@/hooks/web/useMessage';
import { reactive, ref } from 'vue';
/** AI 知识库分段表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'KnowledgeSegmentForm'
  },
  __name: 'KnowledgeSegmentForm',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formType = ref(''); // 表单的类型：create - 新增；update - 修改
    const formData = ref({
      id: undefined,
      documentId: undefined,
      content: undefined
    });
    const formRules = reactive({
      content: [{
        required: true,
        message: '切片内容不能为空',
        trigger: 'blur'
      }]
    });
    const formRef = ref(); // 表单 Ref
    /** 打开弹窗 */
    const open = async (type, id, documentId) => {
      dialogVisible.value = true;
      dialogTitle.value = '知识库分段操作';
      formType.value = type;
      resetForm();
      formData.value.documentId = documentId;
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          formData.value = await KnowledgeSegmentApi.getKnowledgeSegment(id);
        } finally {
          formLoading.value = false;
        }
      }
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        if (formType.value === 'create') {
          await KnowledgeSegmentApi.createKnowledgeSegment(data);
          message.success('创建成功');
        } else {
          await KnowledgeSegmentApi.updateKnowledgeSegment(data);
          message.success('修改成功');
        }
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        documentId: undefined,
        content: undefined
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "切片内容",
            prop: "content"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.content,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.content = $event),
              type: "textarea",
              rows: 6,
              placeholder: "请输入切片内容"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});